module.exports = __webpack_public_path__ + "static/alba-trailer-4c11e97e25c2c6e5a59ab9c1b3cc3863.mp4";